import React from "react";
import Container from 'react-bootstrap/Container';
import { Outlet } from 'react-router-dom';
import PortalLeftNav from "../layout/PortalLeftNav";
import PortalTopNav from "../layout/PortalTopNav";

function PortalLayout() {
    return (
        <Container className="dashboard-container px-0" fluid>
              <PortalLeftNav />
              <main className="main-content">
                <PortalTopNav />
                <Outlet />
              </main>  
        </Container>                    
    );
}

export default PortalLayout;
